export default __webpack_public_path__ + "static/media/poster.b25a3c71.jpg";